import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=402cface&scoped=true&"
import script from "./WorksList.vue?vue&type=script&lang=ts&"
export * from "./WorksList.vue?vue&type=script&lang=ts&"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=402cface&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402cface",
  null
  
)

export default component.exports